import { toast } from "react-hot-toast";
import { BaseButton, SECONDARY } from "components/buttons/BaseButton";
import { useQuery } from "hooks/useQuery";
import { apiMain } from "services";
import "./AuthorizePage.scss";

export const AuthorizePage = () => {
  const query = useQuery();
  const clientId = query.get("client_id") || "";
  const scope = query.get("scope") || "";
  const redirectUri = query.get("redirect_uri") || "";
  const state = query.get("state") || "";

  const handleAllow = async () => {
    try {
      const { url } = await apiMain.getOAuthCode({
        client_id: clientId,
        scope,
        state,
        redirect_uri: redirectUri
      });

      window.location.assign(url);
    } catch (err: any) {
      toast.error("Sorry, could not process your request.");
    }
  };

  const handleReject = () => {
    if (!redirectUri) {
      toast.error("Sorry, could not process your request.");
      return;
    }

    const baseUrl = new URL(redirectUri);
    const params = new URLSearchParams({ error: "deny" });
    const url = `${baseUrl.toString()}?${params.toString()}`;

    window.location.assign(url);
  };

  return (
    <div className="AuthorizePage">
      <h2>Authorization request</h2>
      <div className="AuthorizePage-Wrap">
        <p>An application requests read-only access to your profile.</p>
        <ul>
          <li>The application will be able to read your gifs.</li>
          <li>The application will be able to upload new gifs.</li>
          <li>The application will NOT have access to your password.</li>
        </ul>
        <div className="ButtonsWrap">
          <BaseButton onClick={handleAllow}>Allow</BaseButton>
          <BaseButton variant={SECONDARY} onClick={handleReject}>
            Reject
          </BaseButton>
        </div>
      </div>
    </div>
  );
};
